import { history } from 'lib';
import { stringify } from 'query-string';

export default (data = {}) => history.replace(`${history.location.pathname}?${stringify(data)}`);
